import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function DnsServers(props) {
  function displayDnsResult(server) {
    let s = props.dnsServerResults[server.id];

    if (s != null && s.fetching === false) {
      if (s.data != null) {
        return (
          <>
            {props.dnsServerResults[server.id].data.map((item, i) => {
              return (
                <label key={i} className={"float-right clear break-all " + (props.dnsServerResults[server.id].data.length > 1 ? "multiple-results-border" : "m-0")}>
                  {item}
                </label>
              );
            })}
          </>
        );
      } else if (s.errors != null) {
        return (
          <div>
            {props.dnsServerResults[server.id].errors.map((item, i) => {
              return (
                <p key={i} className="m-0">
                  {item}
                </p>
              );
            })}
          </div>
        );
      }
    }

    return null;
  }

  function getFetchStatus(server) {
    let s = props.dnsServerResults[server.id];

    if (s == null) {
      return <FontAwesomeIcon icon={["far", "dot-circle"]} size="sm" />;
    } else if (s.fetching === true) {
      return <img alt="fetching" src="/img/loading.svg"></img>;
    } else if (s.data != null && s.data.length > 0 && s.success === true) {
      return <FontAwesomeIcon icon={["fas", "check"]} color="green" size="sm" />;
    } else {
      return <FontAwesomeIcon icon={["fas", "times"]} color="#bb0a0a" size="sm" />;
    }
  }

  return (
    <>
      <table id="dns-result-table" className="col-12">
        <tbody>
          {Object.keys(props.dnsServers).map((k) => (
            <tr key={k}>
              <td className="text-left w-1 pl-2">
                <img className="align-middle" width="20" alt={props.dnsServers[k].countryCode.toUpperCase()} src={"/img/country-flags/" + props.dnsServers[k].countryCode.toLowerCase() + ".png"}></img>
              </td>
              <td className="text-left pl-2">
                <label className="m-0 d-block text-nowrap">{props.dnsServers[k].country}</label>
                <label className="m-0 d-block font-11 line-height-14 text-secondary text-nowrap">{props.dnsServers[k].name}</label>
              </td>
              <td className="text-right text-primary text-dark small">{displayDnsResult(props.dnsServers[k])}</td>
              <td className="w-1 pl-2 pr-2">{getFetchStatus(props.dnsServers[k])}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default DnsServers;
